import { shape, number, string, bool, arrayOf } from 'prop-types'

export default shape({
  rid:               number,
  outOfOffice:       bool,
  level:             string,
  prefereedPartners: arrayOf(string),
  preferredLenders:  arrayOf(string)
})
